import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Fetchable } from "../../interfaces/Fetchable";
import { Holder } from "../../interfaces/Holder";
import { Paginated } from "../../interfaces/Paginated";

export interface HolderState {
  allHolders: Partial<Fetchable<Paginated<Holder>>>;
  holder: Partial<Fetchable<Holder>>;
  createdHolder: Partial<Fetchable<Holder>>;
  updatedHolder: Partial<Fetchable<Holder>>;
  deletedHolder: Partial<Fetchable<Holder>>;
  passwordReset: Partial<Fetchable<boolean>>;
}

const initialState: HolderState = {
  allHolders: {},
  holder: {},
  createdHolder: {},
  updatedHolder: {},
  deletedHolder: {},
  passwordReset: {},
};

export const holderSlice = createSlice({
  name: "holder",
  initialState,
  reducers: {
    setError: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof HolderState;
        error: string;
      }>
    ) => {
      state[action.payload.fetchableProp].error = action.payload.error;
    },
    clear: (state, action: PayloadAction<keyof HolderState>) => {
      state[action.payload] = {};
    },
    setLoader: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof HolderState;
        isLoading: boolean;
      }>
    ) => {
      state[action.payload.fetchableProp].isLoading = action.payload.isLoading;
    },
    setPaginatedHolders: (state, action: PayloadAction<Paginated<Holder>>) => {
      state.allHolders.data = action.payload;
      state.allHolders.error = undefined;
    },
    // GET
    setHolder: (state, action: PayloadAction<Holder>) => {
      state.holder.data = action.payload;
      state.holder.error = undefined;
    },
    // CREATE
    createHolder: (state, action: PayloadAction<Holder>) => {
      state.createdHolder.data = action.payload;
      state.createdHolder.error = undefined;
    },
    // UPDATE
    updateHolder: (state, action: PayloadAction<Holder>) => {
      state.updatedHolder.data = action.payload;
      state.updatedHolder.error = undefined;
    },
    // DELETE
    deleteHolder: (state, action: PayloadAction<Holder>) => {
      state.deletedHolder.data = action.payload;
      state.deletedHolder.error = undefined;
    },
    // RESET PASSWORD
    resetPassword: (state, action: PayloadAction<boolean>) => {
      state.passwordReset.data = action.payload;
      state.passwordReset.error = undefined;
    },
  },
});

const actions = { ...holderSlice.actions };

export { actions };
export default holderSlice.reducer;
